import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../styles/NavbarStyles.css";

const Navbar = () => {
  const location = useLocation();
  // Controla la apertura/cierre del menú en pantallas pequeñas
  const [menuOpen, setMenuOpen] = useState(false);

  // Alterna el menú al hacer clic en el botón hamburguesa
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="container">
      <header className="navbar navbar-expand-lg navbar-dark fixed-top">
        <div className="container-fluid">
          {/* Sección izquierda (logo + título) */}
          <div className="navbar-left">
            <img
              src="/images/userImages/Logo.png" // Reemplaza con tu ruta real
              alt="Logo Constructora Cantabria"
              className="navbar-logo"
            />
            <Link
              to="/"
              className="navbar-brand fs-4 text-uppercase"
            >
              CONSTRUCTORA CANTABRIA S.A.S
            </Link>
          </div>

          {/* Botón hamburguesa (solo se ve en pantallas pequeñas) */}
          <button
            className="navbar-toggle"
            onClick={toggleMenu}
            aria-label="Toggle navigation"
          >
            &#9776; {/* Ícono de hamburguesa */}
          </button>

          {/* Opciones del menú */}
          <ul className={`navbar-nav ms-auto ${menuOpen ? "open" : ""}`}>
            <li className="nav-item">
              <Link
                to="/"
                className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                Inicio
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/Projects"
                className={`nav-link ${location.pathname === "/Projects" ? "active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                Proyectos
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/Properties"
                className={`nav-link ${location.pathname === "/Properties" ? "active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                Propiedades
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/About"
                className={`nav-link ${location.pathname === "/About" ? "active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                Quiénes somos
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/Contact"
                className={`nav-link ${location.pathname === "/Contact" ? "active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                Contáctanos
              </Link>
            </li>
          </ul>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
